import { FEATURE_KEYS, MODULE_KEYS, OPERATION_IDS } from '../routes/ids.js';
const tk = (value) => value;
const fieldId = (value) => value;
const required = { rules: [{ ruleId: 'required', messageKey: tk('validation.required') }], validateWhen: 'submit' };
const journalLines = {
    minItems: 2,
    addLabelKey: tk('journal.addLine'),
    removeLabelKey: tk('journal.removeLine'),
    emptyStateKey: tk('journal.balancedLineGuidance'),
    itemLabelKey: tk('form.collection.row'),
    summaryMode: 'journalBalance',
    presentation: 'compactGrid',
    columns: [
        { name: 'ledgerAccountId', labelKey: tk('journal.ledgerAccount'), helpTextKey: tk('journal.balancedLineGuidance'), fieldType: 'select', required: true,
            optionSource: { adapterId: 'api', operationId: OPERATION_IDS.CHART_OF_ACCOUNTS_LIST, valuePath: 'id', labelPath: 'name', descriptionPath: 'code', allowSearch: true, minimumSearchLength: 0 } },
        { name: 'debit', labelKey: tk('journal.debit'), helpTextKey: tk('journal.balancedLineGuidance'), fieldType: 'money' },
        { name: 'credit', labelKey: tk('journal.credit'), helpTextKey: tk('journal.balancedLineGuidance'), fieldType: 'money' },
        { name: 'narration', labelKey: tk('journal.lineNarration'), helpTextKey: tk('journal.balancedLineGuidance'), fieldType: 'text' },
    ],
};
const createAction = {
    id: 'action.accounting.journals.create', schemaVersion: 1,
    module: MODULE_KEYS.ACCOUNTING, feature: FEATURE_KEYS.DATA_JOURNALS,
    privacyClassification: 'FINANCIAL', telemetryId: 'experience.action.journals.create',
    accessibilityLabelKey: tk('journal.create'), availability: 'AVAILABLE', owner: 'accounting',
    operationId: OPERATION_IDS.JOURNALS_CREATE, labelKey: tk('journal.create'), kind: 'command',
    commandId: 'cmd.data.journals.create', method: 'POST', payloadSchemaRef: '#/schemas/command.journals.create',
    invalidationTargets: ['resource.journals'], intent: 'primary', idempotencyRequired: true,
    submitBehavior: 'form_submit', submitConfig: { validatesForm: true, requiresDirty: true, requiresValid: true, resetBehavior: 'toServerValues', payloadBuilderId: 'builder.journal.create' },
    successBehavior: 'NAVIGATE_BACK', successMessageKey: tk('common.saveSuccess'),
    errorBehavior: 'SHOW_INLINE_ERROR',
};
function field(name, fieldType, requiredField = false) {
    const labelKey = name === 'fiscalYearId' ? tk('journal.fiscalYear') : tk(`journal.${name}`);
    return { id: fieldId(`field.journal.${name}`), name, fieldType, labelKey, helpTextKey: tk('journal.balancedLineGuidance'),
        value: { hiddenValuePolicy: 'unregister', submitBehavior: 'include' },
        ...(requiredField ? { validation: required } : {}), layout: { md: fieldType === 'collection' || fieldType === 'textarea' ? 12 : 6 } };
}
export const JOURNAL_CREATE_WORKFLOW_FORM = {
    id: 'form.accounting.journal.create', schemaVersion: 1, module: MODULE_KEYS.ACCOUNTING,
    feature: FEATURE_KEYS.DATA_JOURNALS, privacyClassification: 'FINANCIAL', telemetryId: 'experience.form.journals.create',
    accessibilityLabelKey: tk('journal.createTitle'), availability: 'AVAILABLE', owner: 'accounting',
    titleKey: tk('journal.createTitle'), mode: 'create',
    fields: [field('entryDate', 'date', true), field('fiscalYearId', 'text', true), field('reference', 'text'), field('narration', 'textarea'), { ...field('lines', 'collection', true), collection: journalLines }],
    actions: [createAction], submission: { defaultCommandId: 'cmd.data.journals.create' },
};
